import { ISiteInfo } from '../models/SelectedSites';
import { BaseService } from './BaseService';

export class SitesService extends BaseService {
    public getSitesAsync = async (accessToken: string) => {
        return await this.getResponseAsync<ISiteInfo[]>(
            {
                commandPath: `sites/getSites`,
                method: 'GET',
            },
            accessToken,
        );
    };
}
